module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n\n<router-outlet></router-outlet>\n\n<app-nav-bottom></app-nav-bottom>\n"


//////////////////
// WEBPACK FOOTER
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main